export default "__VITE_ASSET__fc4c9da1__"